import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../utils';

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

const Col = styled.div`
  display: inline-block;
  width: 36px;
`;

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${colors.l01};
  border-radius: 3px;
  height: 30px;
  margin: 3px;
  position: relative;
  width: 30px;
`;

const triangleAnimation = keyframes`
  0% { border-bottom: 17px solid ${colors.l02};}
  25% { border-bottom: 17px solid  ${colors.l03};}
  50% { border-bottom: 17px solid ${colors.l02};}
  75%{border-bottom: 17px solid ${colors.l02};}
  100% {border-bottom: 17px solid ${colors.l02};}
`;

const Triangle = styled.div`
  animation: ${triangleAnimation} 1s infinite;
  border-bottom: 17px solid #b4b5b5;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
`;

const circleAnimation = keyframes`
  0% {background-color: ${colors.l02};}
  25% {background-color: ${colors.l02};}
  50% {background-color: ${colors.l03};}
  75%{background-color: ${colors.l02};}
  100% {background-color: ${colors.l02};}
`;

const Circle = styled.div`
  animation: ${circleAnimation} 1s infinite;
  background-color: #b4b5b5;
  border-radius: 17px;
  height: 17px;
  width: 17px;
`;

const squareAnimation = keyframes`
  0% {background-color: ${colors.l02};}
  25% {background-color: ${colors.l02};}
  50% {background-color: ${colors.l02};}
  75%{background-color: ${colors.l02};}
  100% {background-color: ${colors.l03};}
`;

const Square = styled.div`
  animation: ${squareAnimation} 1s infinite;
  background-color: #329bac;
  height: 16px;
  width: 16px;
`;

const diamondAnimation = keyframes`
  0% {transform: rotate(45deg); background-color: ${colors.l02};}
  25% {transform: rotate(45deg); background-color: ${colors.l02};}
  50% {transform: rotate(45deg); background-color: ${colors.l02};}
  75%{transform: rotate(45deg); background-color: ${colors.l03};}
  100% {transform: rotate(45deg); background-color: ${colors.l02};}
`;

const Diamond = styled.div`
  animation: ${diamondAnimation} 1s infinite;
  background-color: #329bac;
  height: 14px;
  width: 14px;
`;

function Loader() {
  return (
    <Row>
      <Col>
        <Wrapper>
          <Triangle />
        </Wrapper>

        <Wrapper>
          <Square />
        </Wrapper>
      </Col>

      <Col>
        <Wrapper>
          <Circle />
        </Wrapper>

        <Wrapper>
          <Diamond />
        </Wrapper>
      </Col>
    </Row>
  );
}

export { Loader };
